import { ImFire } from "react-icons/im";
import { ProductCard } from "app/components/Product/ProductCard";
import Carousel from "app/components/Carousel";

interface WhatsHotProps {
  products: any[];
}

export function WhatsHot({ products }: WhatsHotProps) {
  if (!products || products.length === 0) {
    return null;
  }

  return (
    <div className="relative px-3 md:px-6 lg:px-8 xl:px-12 my-2.5 md:my-6 max-h-[46rem] 2xl:max-h-[50rem] overflow-hidden">
      <div className="container mx-auto space-y-8 py-4">
        {/* Trending Trigger Section */}
        <div className="w-full mx-auto py-0.5 md:py-3">
          <h1 className="text-primary text-center md:text-2xl text-xl lg:text-3xl font-bold">
            PROMOTIONAL PRODUCTS AT GUARANTEED LOWEST PRICES
          </h1>
        </div>

        <div className="relative border-2 border-orange rounded-lg py-5 sm:py-2 px-2 sm:px-5 2xl:px-12 xl:pb-6">
          <div className="bg-white dark:bg-black p-4 absolute top-[-2rem]">
            <div className="flex justify-between gap-2 font-semibold text-orange-600 text-2xl">
              <ImFire />
              <h2 className="drop-shadow-lg ">WHAT&apos;S HOT</h2>
            </div>
          </div>
          <div className="pt-8 max-h-[31.5rem] overflow-hidden">
            <Carousel numberOfItems={4}>
              {products.map((item: any) => (
                <div key={item._id || item?.id} className="flex flex-row">
                  <ProductCard
                    labels={item?.labels || []}
                    isSpecialSupplier={item?.supplier?.isSpecialSupplier}
                    image={item?.overview?.heroImage}
                    images={item?.product?.images}
                    title={item.overview?.name}
                    productCode={item?.overview.code}
                    description={item?.product.description}
                    userTypePrice={item?.userTypePrice}
                    qty={item?.quantity}
                    slug={item?.slug}
                    category={
                      item?.category?.name ||
                      item?.product?.categorisation?.productType?.typeName
                    }
                    subCatgory={
                      item?.subCategory?.name ||
                      item?.product?.categorisation?.supplierSubCategory
                    }
                  />
                </div>
              ))}
            </Carousel>
          </div>
        </div>
      </div>
    </div>
  );
}
